import React from "react";
export class PositionedOverlayComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    positionPane(el) {
        if (!el || !this.props.shown)
            return;
        const buttonWidth = this.props.buttonRef.current.offsetWidth;
        const paneWidth = el.offsetWidth;
        const buttonLeft = this.props.buttonRef.current.offsetLeft;
        const optimalDelta = Math.floor((paneWidth - buttonWidth) / 2);
        const actualDelta = Math.max(0 - buttonLeft, buttonLeft - optimalDelta);
        if (actualDelta > 0) {
            el.style.left = `${actualDelta}px`;
        }
    }
    createOverlay() {
        this.overlay = document.createElement("div");
        this.overlay.id = `ds-overlay-${this.componentId}`;
        this.overlay.className = "dateselector-overlay";
        this.overlay.style.display = (!this.props.shown) ? "none" : "block";
        this.overlay.onclick = () => {
            this.hideOverlay();
            !!this.props.onCancelled && this.props.onCancelled();
        };
        document.body.appendChild(this.overlay);
    }
    showOverlay() {
        if (!!!this.overlay) {
            return;
        }
        this.overlay.style.display = "block";
    }
    hideOverlay() {
        if (!!!this.overlay) {
            return;
        }
        this.overlay.style.display = "none";
    }
    disposeOverlay() {
        if (!!this.overlay) {
            document.body.removeChild(this.overlay);
        }
    }
}
